import Component from '@glimmer/component';
import { service } from '@ember/service';
import { LinkTo } from '@ember/routing';
import t from 'ember-intl/helpers/t';
import type { IntlService } from 'ember-intl';
import { Header, VStack } from 'tio-ui/components/layout';
import type { RecommendationExtension as RecommendationModel } from 'tio-data/data/resources/recommendation.ext';
import LoanPlansSection from 'tio-employee/components/strategy-finder-0726/loan-plans-section';
import { parseAndFilterResultSections } from 'tio-employee/utils/forgiveness-estimator-0726';

interface ForgivenessEstimator0726ResultsTableSignature {
  Args: {
    recommendation: RecommendationModel;
  };
  Element: HTMLElement;
}

export default class ForgivenessEstimator0726ResultsTableComponent extends Component<ForgivenessEstimator0726ResultsTableSignature> {
  @service declare intl: IntlService;

  // Parse the stored recommendation and filter to PSLF-only plans.
  get sections() {
    return parseAndFilterResultSections(
      this.args.recommendation.calculationInput,
      this.args.recommendation.calculationOutput
    );
  }

  <template>
    <VStack data-test-fe-0726-results ...attributes>
      <Header>
        {{t "strategy_finder_0726.results.title"}}
      </Header>
      {{#if @recommendation.hasErrorsInCalcs}}
        <div class="m-2" data-test-fe-0726-results-error>
          {{t "strategy_finder_0726.results.error_in_calcs"}}
          <LinkTo
            @route="authenticated.pslf.dashboard.forgiveness-estimator-0726.index"
            class="tio-copy"
          >
            {{t "strategy_finder_0726.results.error_link_text"}}
          </LinkTo>
        </div>
      {{else}}
        {{#each this.sections as |section|}}
          <LoanPlansSection @section={{section}} @analysisDate={{@recommendation.createdAt}} />
        {{/each}}
      {{/if}}
    </VStack>
  </template>
}
